import { formatCurrency, parseCurrency } from "../../../util/misc.js";

export const currency = () => formatCurrency;

export const currencyValue = () => parseCurrency;
